import React, { useState, useEffect } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import { useRouter } from 'next/router';
import FollowersComponent from './FollwerComponent';
import { collection, doc, getDoc, getDocs } from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FollowersDialog(props) {
  const router = useRouter();
  const [loadingList, setloadingList] = useState(true);
  const [followersList, setfollowersList] = useState([]);

  useEffect(() => {
    // console.log("call", props.artistId, props.dialogState);

    if (props.artistId && props.dialogState) {
      getFollowers();
    }
  }, [props.artistId, props.dialogState]);

  const getFollowers = async () => {
    // console.log("ruun");
    setloadingList(true);
    let dataRef;
    try {
      dataRef = await getDocs(
        collection(
          firebaseFireStore,
          'musicartArtists',
          props.artistId,
          'followers',
        ),
      );

      if (dataRef.empty) {
        setfollowersList([]);
        setloadingList(false);
        return null;
      }

      let collectorIdsArr = [];
      let dataArr = [];

      dataRef.forEach((doc) => {
        collectorIdsArr.push(doc.id);
      });

      if (collectorIdsArr.length > 0) {
        await Promise.all(
          collectorIdsArr.map(async (collectorId) => {
            //getting seller data
            let sellerRef = await getDoc(
              doc(firebaseFireStore, 'musicartSellers', collectorId),
            );

            if (sellerRef.exists) {
              dataArr.push({ ...sellerRef.data(), id: collectorId });
            }
          }),
        );
      } else {
        setfollowersList([]);
        setloadingList(false);
      }
      setfollowersList([...dataArr]);
      if (followersList) {
        setloadingList(false);
      }

      // setloadingList(false);
    } catch (err) {
      // console.log("err", err);
      setloadingList(false);
    }
  };

  const handleClose = () => {
    props.setdialogState(false);
  };

  return (
    <Dialog
      open={props.dialogState}
      TransitionComponent={Transition}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{
        style: {
          borderRadius: 20,
          width: 450,
        },
      }}
      disableScrollLock={false}
      style={{ zIndex: 999 }}
      maxWidth="md"
      onClose={handleClose}
    >
      <div>
        <div
          className="dialog-titlebar dialog_borderBottom"
          style={{
            padding: '15px 20px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div className="dialog-title" style={{ fontSize: 20 }}>
            Followers
          </div>
          <div style={{ marginLeft: 'auto', marginRight: 10 }}>
            <button
              className="text-black text-lg font-light rounded-full outline-none focus:outline-none border border-gray-300"
              type="button"
              onClick={handleClose}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div>
          <DialogContent
            style={{ minHeight: 300, maxHeight: 500, overflow: 'auto' }}
          >
            {!loadingList &&
              followersList.map((ele, index) => {
                return <FollowersComponent ele={ele} type="Collectors" />;
              })}
            {(() => {
              if (loadingList) {
                return (
                  <div
                    className="flex 	w-full my-6 mx-6 mt-10"
                    style={{ flexDirection: 'column' }}
                  >
                    <Skeleton animation="wave" height={20} width="60%" />
                    <Skeleton animation="wave" height={20} width="60%" />
                    <Skeleton animation="wave" height={20} width="60%" />
                  </div>
                );
              } else if (
                !loadingList &&
                (!followersList || followersList.length === 0)
              ) {
                return <p className="text-center">0 followers found</p>;
              }
            })()}
          </DialogContent>
        </div>
      </div>
    </Dialog>
  );
}
